import Swiper, { Autoplay } from "swiper";

function initAnnouncementBarSwiper() {
  const selector = ".announcement-bar__swiper";
  const el = document.querySelector(selector);

  if (!el) return;

  const swiper = new Swiper(selector, {
    modules: [Autoplay],
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      0: {
        slidesPerView: "auto",
      },
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 2.5,
      },
      1200: {
        slidesPerView: 3,
      },
    },
    init: false,
    loop: true,
  });

  swiper.init();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAnnouncementBarSwiper);
} else {
  initAnnouncementBarSwiper();
}
